// Configuration constants for the application

// API Configuration
export const API_CONFIG = {
  
//BASE_URL: 'http://localhost:8000/',
BASE_URL: 'https://yugmantraa.com/api/',
  
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
};

// Export BASE_URL for backward compatibility
//export const BASE_URL = 'http://localhost:8000/';
export const BASE_URL = 'https://yugmantraa.com/api/';

//export const WEB_SOCKET_URL = 'wss://node.yugmantraa.com';
// export const WEB_SOCKET_URL='wss://siddharth-node-websocket.onrender.com'
export const WEB_SOCKET_URL = 'wss://node-websocket-mwuf.onrender.com'; 

/** App + tab icon: uses `public/logo192.png` (Yug Mantra / Black Gold artwork) */
export const APP_LOGO_URL = `${process.env.PUBLIC_URL || ''}/logo192.png`;

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: 'admin/web/login',
    LOGOUT: 'admin/logout',
  },

  // Dashboard
  DASHBOARD: {
    GET_DATA: 'admin/dashboard/data/get',
  },

  // Profile
  PROFILE: {
    GET: 'admin/profile/get',
    UPDATE: 'admin/profile/update',
  },

  // Brand Management
  BRAND: {
    ADD: 'admin/brand/add',
    GET_ALL: 'brand/get/all',
    UPDATE: 'admin/brand/update',
    DELETE: 'admin/brand/delete',
  },

  // Category Management
  CATEGORY: {
    ADD: 'admin/category/add',
    GET_ALL: 'category/get/all',
    UPDATE: 'admin/category/update',
    DELETE: 'admin/category/delete',
  },

  // Product Management
  PRODUCT: {
    GET_ALL: 'admin/product/get/all',
    GET_BY_ID: 'product/details/get',
    ADD: 'admin/product/add',
    UPDATE: 'admin/product/update',
    DELETE: 'admin/product/delete',
    UPLOAD_IMAGE: 'admin/product/image/upload',
  },

  // Order Management
  ORDER: {
    GET_ALL: 'admin/order/get/all',
    GET_BY_ID: 'order/details/get',
    UPDATE_STATUS: 'admin/order/update/status',
  },

  // Salesperson Management
  SALESPERSON: {
    GET_ALL: 'admin/salesperson/get/all',
    ADD: 'admin/salesperson/add',
    UPDATE: 'admin/salesperson/update',
    DELETE: 'admin/salesperson/delete',
  },

  // User Management
  USER: {
    GET_ALL: 'user/get/all',
    UPDATE_STATUS: 'user/change/active/status',
  },

  // Location Management
  LOCATION: {
    COUNTRY: {
      GET_ALL: 'country/get/all',
      ADD: 'admin/country/add',
      UPDATE: 'admin/country/update',
      DELETE: 'admin/country/delete',
    },
    STATE: {
      GET_ALL: 'state/get/all',
      ADD: 'admin/state/add',
      UPDATE: 'admin/state/update',
      DELETE: 'admin/state/delete',
    },
    CITY: {
      GET_ALL: 'city/get/all',
      ADD: 'admin/city/add',
      UPDATE: 'admin/city/update',
      DELETE: 'admin/city/delete',
    },
    PINCODE: {
      GET_ALL: 'pincode/get/all',
      ADD: 'admin/pincode/add',
      UPDATE: 'admin/pincode/update',
      DELETE: 'admin/pincode/delete',
    },
  },

  // Banner Management
  BANNER: {
    GET_ALL: 'admin/banner/get/all',
    ADD: 'admin/banner/add',
    UPDATE: 'admin/banner/update',
    DELETE: 'admin/banner/delete',
  },

  VIDEO: {
    GET_ALL: 'video/get/all',
    ADD: 'admin/video/add',
    UPDATE: 'admin/video/update',
    DELETE: 'admin/video/delete',
  },

  BROADCAST: {
    SEND: 'admin/broadcast/notification/add',
  },

  // Bank Details
  BANK: {
    GET: 'admin/bank/details/get',
    UPDATE: 'admin/bank/details/update',
  },

  // Settings
  SETTINGS: {
    GET: 'admin/settings/get',
    UPDATE: 'admin/settings/update',
  },

  // Support
  SUPPORT: {
    GET_TICKETS: 'admin/support/ticket/get/all',
    UPDATE_TICKET: 'support/ticket/update/status',
    GET_CHATS: 'support/ticket/get/chats',
    ADD_MESSAGE: 'support/ticket/add/message',
    GET_SUPPORT_TICKET_MESSAGE_COUNT: 'admin/support/ticket/message/count',
  },

  CHAT: {
    GET_USER_LIST:'chat/user/get/all',
    GET_CHATTED_USER_LIST:'admin/chat/users/get',
    GET_CHAT_HISTORY:'chat/history/get',
    ADD_MESSAGE:'chat/message/add',
    MARK_CHAT_MESSAGE_READ: 'chat/message/mark/read',
  },
};

// HTTP Methods
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
};

// Local Storage Keys
export const STORAGE_KEYS = {
  ADMIN_TOKEN: 'adminToken',
  ADMIN_DATA: 'adminData',
  USER_ID: 'userId',
  USER_ID_ALT: 'user_Id',
  REFRESH_TOKEN: 'refreshToken',
};

// User Types
export const USER_TYPES = {
  RETAILER: 'retailer',
  WHOLESELLER: 'wholeseller',
  ADMIN: 'admin',
};

// Product Status
export const PRODUCT_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
};

// Order Status
export const ORDER_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  MAX_LIMIT: 100,
};

// File Upload
export const FILE_UPLOAD = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
  MAX_FILES: 5,
};

// Validation Rules
export const VALIDATION_RULES = {
  PASSWORD_MIN_LENGTH: 6,
  PASSWORD_MAX_LENGTH: 50,
  EMAIL_MAX_LENGTH: 100,
  NAME_MAX_LENGTH: 100,
  PHONE_MAX_LENGTH: 15,
  ADDRESS_MAX_LENGTH: 500,
  DESCRIPTION_MAX_LENGTH: 1000,
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  FORBIDDEN: 'Access denied.',
  NOT_FOUND: 'The requested resource was not found.',
  INTERNAL_ERROR: 'An internal server error occurred.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  TOKEN_EXPIRED: 'Your session has expired. Please login again.',
  INVALID_CREDENTIALS: 'Invalid email or password.',
  REQUIRED_FIELD: 'This field is required.',
  INVALID_EMAIL: 'Please enter a valid email address.',
  PASSWORD_TOO_SHORT: 'Password must be at least 6 characters long.',
  PASSWORD_TOO_LONG: 'Password must be no more than 50 characters long.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Login successful! Redirecting...',
  LOGOUT_SUCCESS: 'Logged out successfully.',
  PROFILE_UPDATED: 'Profile updated successfully.',
  PASSWORD_CHANGED: 'Password changed successfully.',
  ITEM_ADDED: 'Item added successfully.',
  ITEM_UPDATED: 'Item updated successfully.',
  ITEM_DELETED: 'Item deleted successfully.',
  STATUS_UPDATED: 'Status updated successfully.',
};

// UI Constants
export const UI_CONSTANTS = {
  TOAST_DURATION: 3000,
  DEBOUNCE_DELAY: 300,
  ANIMATION_DURATION: 300,
  LOADING_DELAY: 1000,
};

export const DATE_FORMATS = {
  DISPLAY: 'DD/MM/YYYY',
  API: 'YYYY-MM-DD',
  DATETIME: 'DD/MM/YYYY HH:mm',
  TIME: 'HH:mm',
};

export const CURRENCY = {
  SYMBOL: '₹',
  CODE: 'INR',
  NAME: 'Indian Rupee',
};

export default {
  API_CONFIG,
  API_ENDPOINTS,
  HTTP_METHODS,
  HTTP_STATUS,
  STORAGE_KEYS,
  USER_TYPES,
  PRODUCT_STATUS,
  ORDER_STATUS,
  PAGINATION,
  FILE_UPLOAD,
  VALIDATION_RULES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  UI_CONSTANTS,
  DATE_FORMATS,
  CURRENCY,
}; 

export const FIREBASE_CONFIG = {
  API_KEY: 'AIzaSyC0bB70Q3L50Hl01lQ9fneRNTJrKjnr2nU',
  AUTH_DOMAIN: 'siddharth-893ac.firebaseapp.com',
  PROJECT_ID: 'siddharth-893ac',
  STORAGE_BUCKET: 'siddharth-893ac.firebasestorage.app',
  MESSAGING_SENDER_ID: '101910309624',
  APP_ID: '1:101910309624:web:722e38901c63b9d0e4e90d',
  VAPID_KEY: 'BL1y7buEs2gPNtXYavBwnty5v1NV-TMnfhdazxz8znrflrq-Kz_t6sVJARZ75_Nx9SPs7G0yfKqInmnPfNOH3Zk',
  MEASUREMENT_ID: 'G-E6E6HK64RS',
};